
<div class="container">
  <h1>404</h1>
  <p>
    You've tried to open "http://localhost:4200/{{ pathName }}" but alas there is nothing there :(
  </p>
<a href="/login" class="home-link">GO BACK HOME</a>
</div>